module.exports = __webpack_public_path__ + "assets/01c0a45eed3b43426685165dae844ab1.png";